import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/bike.svg'
import _imports_1 from '@/assets/icons/gift.svg'
import _imports_2 from '@/assets/icons/chevron-forward-primary.svg'
import _imports_3 from '@/assets/icons/profile-suggested.svg'
import _imports_4 from '@/assets/icons/team-suggested.svg'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "flex flex-col h-screen" }
const _hoisted_3 = { class: "flex-grow bg-background shadow-inner" }
const _hoisted_4 = { class: "container py-8" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 1,
  class: "flex flex-col"
}
const _hoisted_7 = { class: "flex flex-row justify-between items-center" }
const _hoisted_8 = { class: "text-3xl" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, null, -1)
const _hoisted_10 = { class: "grid grid-cols-2 gap-4 pt-8" }
const _hoisted_11 = { class: "flex flex-col" }
const _hoisted_12 = {
  key: 0,
  class: "flex flex-col bg-white shadow rounded-2xl p-8"
}
const _hoisted_13 = { class: "flex flex-row justify-between" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Incoming members", -1)
const _hoisted_15 = {
  key: 0,
  class: "flex flex-col justify-center items-center mt-4"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-12 h-12 mb-2"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "No incoming members", -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      class: "mr-2"
    }),
    /*#__PURE__*/_createElementVNode("span", null, " Onboarding ")
  ])
], -1)
const _hoisted_20 = { class: "flex flex-row justify-between items-center shadow bg-white rounded-2xl p-8 mt-4" }
const _hoisted_21 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_22 = { class: "text-lg font-semibold" }
const _hoisted_23 = { class: "flex flex-row text-gray-500 pt-4" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "For total of", -1)
const _hoisted_25 = { class: "ml-2" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1 uppercase" }, "usd", -1)
const _hoisted_27 = {
  key: 1,
  class: "flex flex-col bg-white shadow rounded-2xl p-8 mt-4"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row justify-between" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Upcoming birthdays")
], -1)
const _hoisted_29 = {
  key: 0,
  class: "flex flex-col justify-center items-center mt-4"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-12 h-12 mb-4"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "No birthdays this month", -1)
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "flex flex-row items-center" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_35 = { class: "ml-4" }
const _hoisted_36 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_37 = { class: "flex flex-col bg-white shadow rounded-2xl p-8" }
const _hoisted_38 = { class: "flex flex-row justify-between items-start" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Paid this month", -1)
const _hoisted_40 = { class: "flex flex-row items-center" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { class: "flex flex-row items-end py-8" }
const _hoisted_43 = {
  key: 0,
  class: "text-4xl font-bold text-left"
}
const _hoisted_44 = {
  key: 1,
  class: "text-4xl font-bold text-left"
}
const _hoisted_45 = { class: "font-bold ml-2 uppercase" }
const _hoisted_46 = { class: "flex flex-row bg-background-secondary text-xl justify-center rounded-2xl p-4" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" Payment on ")
const _hoisted_48 = { class: "font-semibold ml-2" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", null, "No payment", -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = { class: "flex flex-col bg-white shadow rounded-2xl p-8 mt-4 text-lg" }
const _hoisted_53 = { class: "flex flex-row justify-between" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Timeline", -1)
const _hoisted_55 = { class: "flex flex-row" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 0,
  class: "flex flex-col pt-8"
}
const _hoisted_58 = { class: "flex flex-row items-center" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "uppercase text-gray-400" }, "Suggested actions", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300 mx-4" }, null, -1)
const _hoisted_61 = { class: "grid grid-cols-2 gap-4 pt-4" }
const _hoisted_62 = { class: "flex flex-row bg-white shadow rounded-2xl p-8 justify-between items-start" }
const _hoisted_63 = { class: "flex flex-col" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Edit your profile", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 pt-2 mr-4" }, " Edit your account details, change your password and update payment settings. ", -1)
const _hoisted_66 = { class: "pt-4" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "pr-4" }, "Edit your profile"),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1)
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center rounded bg-green-100 p-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    class: "h-6 w-6"
  })
], -1)
const _hoisted_70 = { class: "flex flex-row bg-white shadow rounded-2xl p-8 justify-between items-start" }
const _hoisted_71 = { class: "flex flex-col justify-between h-full" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Manage accounts", -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 pt-2" }, " Add, edit or remove team members. ", -1)
const _hoisted_74 = { class: "pt-4" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "pr-4" }, "Invite account member"),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
], -1)
const _hoisted_76 = [
  _hoisted_75
]
const _hoisted_77 = /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center rounded bg-orange-100 p-4" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    class: "h-6 w-6"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_ErrorState = _resolveComponent("ErrorState")!
  const _component_UserCard = _resolveComponent("UserCard")!
  const _component_DateFormatter = _resolveComponent("DateFormatter")!
  const _component_Timeline = _resolveComponent("Timeline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Navbar),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Spinner, { key: 0 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_ctx.error)
                  ? (_openBlock(), _createBlock(_component_ErrorState, { key: 0 }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("span", _hoisted_8, "Good " + _toDisplayString(_ctx.greeting) + ", " + _toDisplayString(_ctx.userFirstName + " " + _ctx.userLastName) + "!", 1),
                        _hoisted_9
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          (_ctx.dashboard.incoming_members)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  _hoisted_14,
                                  _createElementVNode("button", {
                                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/talent'))),
                                    class: "text-primary"
                                  }, " See all ")
                                ]),
                                (_ctx.dashboard.incoming_members.length === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_18))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboard.incoming_members, (emp, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: i,
                                    class: "flex flex-row justify-between items-center mt-4"
                                  }, [
                                    _createVNode(_component_UserCard, {
                                      id: emp.id,
                                      firstName: emp.first_name,
                                      lastName: emp.last_name,
                                      position: emp.job_title
                                    }, null, 8, ["id", "firstName", "lastName", "position"]),
                                    _hoisted_19
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_20, [
                            (_ctx.dashboard.reimbursement_requests)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                  _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.dashboard.reimbursement_requests.count) + " reimbursements requests ", 1),
                                  _createElementVNode("div", _hoisted_23, [
                                    _hoisted_24,
                                    _createElementVNode("span", _hoisted_25, " $" + _toDisplayString((
                              _ctx.dashboard.reimbursement_requests.total / 100
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1),
                                    _hoisted_26
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/reimbursements'))),
                              class: "btn-filled-sm"
                            }, " Review ")
                          ]),
                          (_ctx.dashboard.upcoming_birthdays)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                _hoisted_28,
                                (_ctx.dashboard.upcoming_birthdays.length === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, _hoisted_32))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dashboard.upcoming_birthdays, (emp, i) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: i,
                                    class: "flex flex-row items-center justify-between pt-4"
                                  }, [
                                    _createVNode(_component_UserCard, {
                                      firstName: emp.first_name,
                                      lastName: emp.last_name,
                                      position: emp.job_title
                                    }, null, 8, ["firstName", "lastName", "position"]),
                                    _createElementVNode("div", _hoisted_33, [
                                      _hoisted_34,
                                      _createElementVNode("span", _hoisted_35, _toDisplayString(emp.bday), 1)
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.dashboard.upcoming_payment)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createElementVNode("div", _hoisted_38, [
                                  _hoisted_39,
                                  _createElementVNode("div", _hoisted_40, [
                                    _createElementVNode("button", {
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/payroll'))),
                                      class: "btn-filled-sm"
                                    }, " Review ")
                                  ])
                                ]),
                                (_ctx.dashboard.upcoming_payment.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                      _createElementVNode("div", _hoisted_42, [
                                        (_ctx.currency === 'usd')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_43, " $" + _toDisplayString((
                              _ctx.dashboard.upcoming_payment[0].payrolls_total / 100
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1))
                                          : _createCommentVNode("", true),
                                        (_ctx.currency === 'mxn')
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_44, " $" + _toDisplayString((
                              (_ctx.dashboard.upcoming_payment[0].payrolls_total *
                                _ctx.dashboard.upcoming_payment[0].exchange_rate) /
                              100
                            ).toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })), 1))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.currency), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_46, [
                                        _hoisted_47,
                                        _createElementVNode("span", _hoisted_48, [
                                          _createVNode(_component_DateFormatter, {
                                            date: _ctx.dashboard.upcoming_payment[0].end_date
                                          }, null, 8, ["date"])
                                        ])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_51))
                              ]),
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("div", _hoisted_53, [
                                  _hoisted_54,
                                  _createElementVNode("div", _hoisted_55, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timelineOptions, (item, i) => {
                                      return (_openBlock(), _createElementBlock("button", {
                                        key: i,
                                        class: _normalizeClass(["text-gray-300 mx-4", { 'text-primary': item.isActive }]),
                                        onClick: ($event: any) => (_ctx.changeTimelineParams(i))
                                      }, _toDisplayString(item.name), 11, _hoisted_56))
                                    }), 128))
                                  ])
                                ]),
                                _createVNode(_component_Timeline, {
                                  type: _ctx.timelineParams.type,
                                  value: _ctx.timelineParams.value,
                                  key: _ctx.componentKey,
                                  class: "mt-4"
                                }, null, 8, ["type", "value"])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.showSuggestions)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, [
                              _hoisted_59,
                              _hoisted_60,
                              _createElementVNode("button", {
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.stopShowingSuggestions && _ctx.stopShowingSuggestions(...args))),
                                class: "text-gray-400"
                              }, " Don't show again ")
                            ]),
                            _createElementVNode("div", _hoisted_61, [
                              _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("div", _hoisted_63, [
                                  _hoisted_64,
                                  _hoisted_65,
                                  _createElementVNode("div", _hoisted_66, [
                                    _createElementVNode("button", {
                                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/settings/account-settings'))),
                                      class: "space-y-3 text-primary px-4 py-2 rounded-full border-2 border-primary"
                                    }, _hoisted_68)
                                  ])
                                ]),
                                _hoisted_69
                              ]),
                              _createElementVNode("div", _hoisted_70, [
                                _createElementVNode("div", _hoisted_71, [
                                  _hoisted_72,
                                  _hoisted_73,
                                  _createElementVNode("div", _hoisted_74, [
                                    _createElementVNode("button", {
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.push('/settings/account-members'))),
                                      class: "space-y-3 text-primary px-4 py-2 rounded-full border-2 border-primary"
                                    }, _hoisted_76)
                                  ])
                                ]),
                                _hoisted_77
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
              ]))
        ])
      ])
    ])
  ]))
}